<template>
  <div
      v-if="showNavbar && !isRoomsRoute"
      class="header-bar d-flex align-items-center justify-content-left d-md-none"
      :class="{ 'header-bar-home': $route.name === 'home' }"
      :style="{ paddingTop: navbarTopInset + 6 + 'px' }"
  >
    <!-- Back Button -->
    <b-button
        @click="$emit('back')"
        class="btn btn-outline btn-sidebar mr-2 ml-2"
        :class="{ 'd-none': $route.name === 'home' }"
    >
      <i class="pi pi-angle-left"></i>
    </b-button>

    <!-- Title -->
    <div
        class="text-uppercase f4"
        :class="{ 'd-none': $route.name === 'home' }"
    >
      {{ headerbarTitle }}
    </div>

    <!-- Toggle Sidebar -->
    <b-button
        class="btn-sidebar ml-auto mr-3"
        v-b-toggle.sidebar-right.sidebar-backdrop.sidebar-footer
    >
      <i class="pi pi-bars"></i>
    </b-button>
  </div>
</template>

<script>
export default {
  name: "NavbarMobile",
  props: {
    showNavbar: { type: Boolean, default: true },
    isRoomsRoute: { type: Boolean, default: false },
    navbarTopInset: { type: Number, default: 0 },
    headerbarTitle: { type: String, default: "" },
  }
};
</script>
